module.exports = __webpack_public_path__ + "img/topg.org.240c04b5.gif";